<template>
    <!-- display qr code reader -->
    <v-row justify="space-around" no-gutters v-if="showSwappMessage === false && swappDifficulties === false">
        <!-- qr code reader component -->
        <v-col cols="12" class="my-0 py-0">
            <qrCodeReader />
        </v-col>
        <!-- instructions -->
        <v-row class="text-left mx-2">
            <v-col cols="12">
                <app-text category="content-title" class="text-uppercase">SWAPP {{ $route.params.direction }}</app-text>
            </v-col>

            <v-col cols="12" class="py-0">
                <app-text category="tab-text">1. Allow your camera when prompted</app-text>
            </v-col>

            <v-col cols="12" class="py-0">
                <app-text category="tab-text">2. Point your camera at the poster</app-text>
            </v-col>

            <v-col cols="12" class="py-0">
                <app-text category="tab-text">3. Make sure the QR Code is visible in the box above.</app-text>
            </v-col>

            <v-col cols="12" class="pt-4 pb-0 d-flex justify-center">
                <appbutton
                    type="secondary"
                    sizeoverride="medium"
                    :label="'SWAPP a Member of Staff'"
                    iconclass="white--text"
                    @click.native="showColleague()"
                />
            </v-col>
            <!-- <v-col cols="12" class="d-flex justify-center">
                <v-btn class="elevation-0" color="secondary" medium>
                    <span @click="swappDifficulties = true" class="white--text">Can't swapp {{ $route.params.direction }}?</span>
                </v-btn>
            </v-col> -->
            <!-- <pre>{{ swappDifficulties }}</pre>
            <pre>{{ showSwappColleague }}</pre>
            <pre>{{ showSwappMessage }}</pre> -->
        </v-row>
    </v-row>

    <v-row v-else-if="showSwappColleague && showSwappMessage && swappDifficulties === false" no-gutters>
        <v-col cols="12" class="pl-2 py-3 d-flex justify-start">
            <appbutton type="secondary" icon="icons8-back-to" label="Back" iconclass="white--text" @click.native="returnToSwapp()" />
        </v-col>

        <v-col cols="12" class="text-left pa-3 pt-0">
            <v-card flat class="pa-4 mb-3 grey lighten-4">
                <div class="text-h7 secondary--text font-weight-bold">Select the Staff Member from the drop down below:</div>
                <v-col class="pa-0" cols="12">
                    <v-autocomplete
                        :menu-props="{ top: false, offsetY: true }"
                        :attach="true"
                        color="black"
                        label="Select Member of Staff"
                        v-model="staffMembers"
                        :items="computedUsersfromOrganisations"
                        item-text="userName"
                        clearable
                        return-object
                        filled
                        hide-details="auto"
                        required
                        background-color="grey lighten-4"
                        dense
                    >
                        <template v-slot:item="data">
                            {{ data.item.userName }}
                        </template>
                        <template v-slot:selection="data">
                            {{ data.item.userName }}
                        </template>
                    </v-autocomplete>
                </v-col>
                <div class="body-2 pt-2 grey--text text--darken-1">
                    <!-- {{ staffMembers}} -->
                </div>
                <div v-if="staffMembers">
                    <div v-if="staffMembers.swappStatus == 0" class="body-2 pt-2 grey--text text--darken-1">
                        This Staff Member is currently SWAPP'd<span class="font-weight-bold"> OUT</span>, you are now SWAPP-ing them
                        <span class="font-weight-bold">IN</span>.
                    </div>
                    <div v-if="staffMembers && staffMembers.swappStatus == 1" class="body-2 pt-2 grey--text text--darken-1">
                        This Staff Member is currently SWAPP'd IN, you are now SWAPPing them OUT.
                    </div>
                    <div v-if="staffMembers" class="body-2 pt-2 grey--text text--darken-1">
                        Please select the reason why the colleague is unable to SWAPP themselves from the list below:
                    </div>
                    <v-col v-if="staffMembers" class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <v-select
                            label="Reason?"
                            v-model="swappReason"
                            required
                            :items="swappReasons"
                            item-text="text"
                            item-value="value"
                            dense
                            background-color="grey lighten-4"
                            filled
                            hide-details="auto"
                            class="mb-2"
                        >
                            <template v-slot:item="data"> {{ data.item }} </template> <template v-slot:selection="data"> {{ data.item }} </template>
                        </v-select>
                    </v-col>
                    <v-col v-if="swappReason" class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <v-select
                            label="Site?"
                            v-model="swappSite"
                            required
                            :items="computedSites"
                            item-text="text"
                            @change="getLocations()"
                            item-value="value"
                            dense
                            background-color="grey lighten-4"
                            filled
                            hide-details="auto"
                            class="mb-2"
                        >
                            <template v-slot:item="data"> {{ data.item.siteName }} </template>
                            <template v-slot:selection="data"> {{ data.item.siteName }} </template>
                        </v-select>
                    </v-col>
                    <v-col v-if="swappSite" class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                        <v-select
                            label="Location?"
                            v-model="swappLocation"
                            required
                            :items="locations"
                            item-text="text"
                            item-value="value"
                            dense
                            background-color="grey lighten-4"
                            filled
                            hide-details="auto"
                            class="mb-2"
                        >
                            <template v-slot:item="data"> {{ data.item.locationName }} </template>
                            <template v-slot:selection="data"> {{ data.item.locationName }} </template>
                        </v-select>
                    </v-col>
                    <v-btn v-if="swappLocation && staffMembers.swappStatus == 1" class="elevation-0 mt-2" width="100%" color="secondary" medium>
                        <span @click="swappUser()" class="white--text">SWAPP USER OUT of this site</span>
                    </v-btn>
                    <v-btn v-if="swappLocation && staffMembers.swappStatus == 0" class="elevation-0 mt-2" width="100%" color="secondary" medium>
                        <span @click="swappUser()" class="white--text">SWAPP USER IN to this site</span>
                    </v-btn>
                </div>
            </v-card>
        </v-col>
    </v-row>

    <v-row class="align-center" height="100%" no-gutters v-else-if="swappDifficulties">
        <v-col cols="12" class="pl-2 py-3 d-flex justify-start">
            <appbutton type="secondary" icon="icons8-back-to" label="Back" iconclass="white--text" @click.native="returnToSwapp()" />
        </v-col>
        <v-col cols="12" class="text-left pa-3 pt-0">
            <v-card flat class="pa-4 mb-3 grey lighten-4">
                <div class="text-h7 secondary--text font-weight-bold">
                    Having Trouble SWAPPING <span class="text-uppercase">{{ $route.params.direction }}</span
                    ><span v-if="$route.params.direction == 'out'"> from {{ GET_currentUser.lastSite.siteName }}</span
                    >?
                </div>
                <div class="body-2 grey--text text--darken-1">
                    <p>
                        If you're having trouble SWAPPING <span class="text-capitalize">{{ $route.params.direction }} </span> using the QR Code,
                        select the reason from the list below.
                    </p>
                </div>
                <v-col class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-select
                        label="Reason?"
                        v-model="swappReason"
                        required
                        :items="swappReasons"
                        item-text="text"
                        item-value="value"
                        dense
                        background-color="grey lighten-4"
                        filled
                        hide-details="auto"
                        class="mb-2"
                    >
                        <template v-slot:item="data"> {{ data.item }} </template> <template v-slot:selection="data"> {{ data.item }} </template>
                    </v-select>
                </v-col>
                <v-col v-if="swappReason" class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-select
                        label="Site?"
                        v-model="swappSite"
                        required
                        :items="computedSites"
                        item-text="text"
                        @change="getLocations()"
                        item-value="value"
                        dense
                        background-color="grey lighten-4"
                        filled
                        hide-details="auto"
                        class="mb-2"
                    >
                        <template v-slot:item="data"> {{ data.item.siteName }} </template>
                        <template v-slot:selection="data"> {{ data.item.siteName }} </template>
                    </v-select>
                </v-col>
                <v-col v-if="swappSite" class="pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-select
                        label="Location?"
                        v-model="swappLocation"
                        required
                        :items="locations"
                        item-text="text"
                        item-value="value"
                        dense
                        background-color="grey lighten-4"
                        filled
                        hide-details="auto"
                        class="mb-2"
                    >
                        <template v-slot:item="data"> {{ data.item.locationName }} </template>
                        <template v-slot:selection="data"> {{ data.item.locationName }} </template>
                    </v-select>
                </v-col>
                <v-btn v-if="swappReason && $route.params.direction == 'out'" class="elevation-0 mt-2" width="100%" color="secondary" medium>
                    <span @click="swappDifficulty()" class="white--text">SWAPP {{ $route.params.direction }} from this site</span>
                </v-btn>
                <v-btn v-if="swappSite && $route.params.direction == 'in'" class="elevation-0 mt-2" width="100%" color="secondary" medium>
                    <span @click="swappDifficulty()" class="white--text">SWAPP {{ $route.params.direction }} to this site</span>
                </v-btn>
            </v-card>
        </v-col>
    </v-row>

    <!-- display qr code result -->
    <v-row class="mt-10" no-gutters v-else>
        <v-col cols="12" class="text-center">
            <h3 class="font-weight-medium">
                You have SWAPPED <span v-if="staffMembers" class="font-weight-bold">{{ staffMembers.userName }} </span
                ><span class="text-uppercase">{{ swappValue() }}</span>
            </h3>
        </v-col>
        <v-col cols="12" class="text-center">
            <v-icon class="primary--text" size="150">icons8-checkmark-yes</v-icon>
        </v-col>
        <!-- <v-col cols="12" class="text-center">
            <h3 class="font-weight-medium text-uppercase">{{ $route.params.direction }}</h3>
        </v-col> -->
        <v-col v-if="locationDetails != null && locationDetails != undefined" cols="12" class="text-center">
            <h3 class="text-uppercase">{{ locationDetails.locationName }}</h3>
        </v-col>
        <!-- go home button -->
        <v-col cols="12" class="mt-8 text-center">
            <appbutton label="HOME" sizeoverride="large" type="secondary" @click.native="MIX_go('/')" />
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Swapp',
    data: () => ({
        locationDetails: [], // store the qr code location result
        form: {}, // store the curr user details
        showSwappMessage: false, // show qr code reader/result
        showSwappColleague: false, // show swapp in colleague form
        usersFromOrganisation: [],
        staffMembers: '',
        formBackground: 'white',
        showSwapp: false,
        swappDifficulties: false,
        swappReason: '',
        swappReasons: ['Already Left Site', 'Cannot find QR Code', 'Camera not working', 'Unable to scan QR Code'],
        swappSite: '',
        swappLocation: '',
        sitesData: [],
        locationsData: []
    }),
    computed: {
        ...mapGetters({
            GET_QR_Result: 'qr_code_reader_store/GET_getResult', // impoert qr code result from store
            GET_currentUser: 'GET_currentUser'
        }),
        //check route direction value and return
        returnSwappValue() {
            if (this.$route.params.direction === 'in') {
                return 1
            } else {
                return 0
            }
        },
        computedUsersfromOrganisations() {
            if (this.usersFromOrganisation !== '[]' || this.usersFromOrganisation.length !== '0') {
                return this.usersFromOrganisation
            }
        },
        computedSites() {
            var sites = []
            sites = this.sitesData
            return sites.map(e => {
                return {
                    id: e.id,
                    siteName: e.siteName,
                    siteAddress: e.siteAddress,
                    siteContact: e.siteContact
                }
            })
        },
        locations() {
            var locations = this.locationsData
            return locations.map(e => {
                return {
                    id: e.id,
                    locationName: e.locationName
                }
            })
        }
    },
    // * WATCH
    watch: {
        // Watch for a change in the QR CODE RESULT
        GET_QR_Result: {
            handler() {
                this.getLocation() // trigger get location details based on qr code result
            },
            deep: true
        },
        // watch for a change in the location result
        locationDetails: {
            handler() {
                this.swapp() // trigger update swapp status when a location is returned
            },
            deep: true
        }
    },
    methods: {
        async getLocation() {
            if (this.GET_QR_Result !== null || this.GET_QR_Result !== '' || this.GET_QR_Result != undefined) {
                var locationResult = await this.MIX_readDocumentById('locations', this.GET_QR_Result)
                if (locationResult.code === 1) {
                    this.locationDetails = locationResult.data
                } else {
                }
            }
        },
        swappInColleague() {
            var t = this
        },
        showColleague() {
            this.showSwappColleague = true
            this.showSwappMessage = true
            this.getUsersFromOrganisation()
        },
        returnToSwapp() {
            this.showSwappColleague = false
            this.showSwappMessage = false
            this.swappDifficulties = false
            this.staffMembers = ''

            // Reset form fields
            this.swappSite = ''
            this.swappLocation = ''
            this.swappReason = ''
        },
        swappValue() {
            if (this.form.swappStatus === 1) {
                return 'in'
            } else {
                return 'out'
            }
        },
        //GET SITES METHOD
        getUsersFromOrganisation: async function() {
            var t = this
            t.$firebase.db
                .collection('users')
                .where('organisation.organisationId', '==', t.GET_currentUser.organisation.organisationId)
                .onSnapshot(function(querySnapshot) {
                    t.usersFromOrganisation = []
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            t.usersFromOrganisation.push(document)
                        } else {
                            // Do not Show Concern
                        }
                    })
                    // console.log("users from organisation = " + JSON.stringify(t.usersFromOrganisation, null, 2))
                })
        },
        //GET SITES METHOD
        getSites: async function() {
            var t = this
            t.$firebase.db.collection('sites').onSnapshot(function(querySnapshot) {
                t.sitesData = []
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id
                    if (!document.hasOwnProperty('delete')) {
                        t.sitesData.push(document)
                    } else if (t.showDeleted) {
                        t.sitesData.push(document)
                    } else {
                        // Do not Show Concern
                    }
                })
            })
        },
        // GET LOCATIONS METHOD
        getLocations: async function() {
            var t = this
            if (this.swappSite) {
                t.$firebase.db
                    .collection('locations')
                    .where('site.id', '==', this.swappSite.id)
                    .onSnapshot(function(querySnapshot) {
                        t.locationsData = []
                        querySnapshot.forEach(function(doc) {
                            var document = doc.data()
                            document.id = doc.id
                            if (!document.hasOwnProperty('delete')) {
                                t.locationsData.push(document)
                            } else {
                                // Do not Show Concern
                            }
                        })
                    })
            }
        },
        async swappUser() {
            // When swapping a colleague in, also check for site mismatch
            if (this.form.swappStatus == 0 && this.$route.params.direction === 'in') {
                const selectedSiteId = localStorage.getItem('selectedSiteId')
                if (selectedSiteId && this.swappSite && this.swappSite.id !== selectedSiteId) {
                    // Get the selected site name from localStorage if available
                    let selectedSiteName = localStorage.getItem('selectedSiteName') || 'the site you selected'

                    // Access the siteName property directly - this is how it's displayed in the template
                    const currentSiteName = this.swappSite && this.swappSite.siteName ? this.swappSite.siteName : 'a different site'

                    // The MIX_alert function only displays the message parameter, not data
                    this.MIX_alert(
                        -1,
                        `Site Mismatch: You are trying to swapp into ${currentSiteName}, but you must swapp into ${selectedSiteName}. Please go back and select ${selectedSiteName} from the site dropdown.`,
                        null,
                        null
                    )
                    return
                }
            }

            this.form = this.staffMembers
            this.form.lastLocation.locationId = this.swappLocation.id
            this.form.lastLocation.locationName = this.swappLocation.locationName
            this.form.lastSite.siteId = this.swappSite.id
            this.form.lastSite.siteName = this.swappSite.siteName
            if (this.form.swappStatus == 1) {
                this.form.swappStatus = 0 // set Swapp status
            } else if (this.form.swappStatus == 0) {
                this.form.swappStatus = 1
            }
            this.form.swappMethod = 'FORM'
            this.form.swappedTime = this.$moment().format('X')
            // console.log(JSON.stringify(this.form, null, 2))
            //update the swapp status in the user document
            var updateDocumentResult = await this.MIX_updateDocument('users', this.form)
            if (updateDocumentResult.code === 1) {
                this.MIX_alert(1, 'Swapp Status Updated', updateDocumentResult.data, null)
                this.swappDifficulties = false
                this.showSwappMessage = true // show success message
                this.showSwappColleague = false
                ;(this.swappSite = ''), (this.swappLocation = ''), (this.sitesData = []), (this.locationsData = []), (this.swappReason = '')
                // Clear the selected site from localStorage after successful swap
                localStorage.removeItem('selectedSiteId')
            } else {
                this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult.error)
                this.showSwappMessage = false // show error message
            }
        },

        async swappDifficulty() {
            // Check for site mismatch when using the form for swapping in
            if (this.$route.params.direction === 'in') {
                const selectedSiteId = localStorage.getItem('selectedSiteId')
                if (selectedSiteId && this.swappSite && this.swappSite.id !== selectedSiteId) {
                    // Get the selected site name from localStorage if available
                    let selectedSiteName = localStorage.getItem('selectedSiteName') || 'the site you selected'

                    // Access the siteName property directly - this is how it's displayed in the template
                    const currentSiteName = this.swappSite && this.swappSite.siteName ? this.swappSite.siteName : 'a different site'

                    // The MIX_alert function only displays the message parameter, not data
                    this.MIX_alert(
                        -1,
                        `Site Mismatch: You are trying to swapp into ${currentSiteName}, but you must swapp into ${selectedSiteName}. Please go back and select ${selectedSiteName} from the site dropdown.`,
                        null,
                        null
                    )
                    return
                }
            }

            this.form = this.GET_currentUser
            this.form.lastLocation.locationId = this.swappLocation.id
            this.form.lastLocation.locationName = this.swappLocation.locationName
            this.form.lastSite.siteId = this.swappSite.id
            this.form.lastSite.siteName = this.swappSite.siteName
            this.form.swappStatus = this.returnSwappValue // set Swapp status
            this.form.swappMethod = 'FORM'
            this.form.swappedTime = this.$moment().format('X')
            // console.log(JSON.stringify(this.form, null, 2))
            //update the swapp status in the user document
            var updateDocumentResult = await this.MIX_updateDocument('users', this.form)
            if (updateDocumentResult.code === 1) {
                this.MIX_alert(1, 'Swapp Status Updated', updateDocumentResult.data, null)
                this.swappDifficulties = false
                this.showSwappMessage = true // show success message
                ;(this.swappSite = ''), (this.swappLocation = ''), (this.sitesData = []), (this.locationsData = []), (this.swappReason = '')
                // Clear the selected site from localStorage after successful swap
                localStorage.removeItem('selectedSiteId')
            } else {
                this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult.error)
                this.showSwappMessage = false // show error message
            }
        },

        async swapp() {
            //set the values changed when you swapp in/out
            this.form = this.GET_currentUser // assign current logged in user to our local var form

            // Check if selectedSite from localStorage matches the site being swapped into
            // Only perform this check when swapping in (status 0 -> 1)
            const selectedSiteId = localStorage.getItem('selectedSiteId')
            if (
                this.$route.params.direction === 'in' &&
                selectedSiteId &&
                this.locationDetails &&
                this.locationDetails.site &&
                this.locationDetails.site.id !== selectedSiteId
            ) {
                // Get the selected site name from localStorage if available
                let selectedSiteName = localStorage.getItem('selectedSiteName') || 'the site you selected'

                // Access the siteName properly
                const currentSiteName =
                    this.locationDetails.site && this.locationDetails.site.siteName ? this.locationDetails.site.siteName : 'a different site'

                // Site mismatch - show error with specific site information
                // The MIX_alert function only displays the message parameter, not data
                this.MIX_alert(
                    -1,
                    `Site Mismatch: You are trying to swapp into ${currentSiteName}, but you must swapp into ${selectedSiteName}. Please go back and scan a QR code at ${selectedSiteName}.`,
                    null,
                    null
                )
                return
            }

            if (this.form.swappStatus === 1 && this.form.lastLocation.locationId !== this.locationDetails.id) {
                this.form.swappStatus = 0
                this.form.swappMethod = 'QRPHONE'
                await this.MIX_updateDocument('users', this.form)
                this.form.swappStatus = 1
                this.form.lastLocation.locationId = this.locationDetails.id // set locationId
                this.form.lastLocation.locationName = this.locationDetails.locationName // set locationName
                this.form.lastSite.siteId = this.locationDetails.site.id // set siteId
                this.form.lastSite.siteName = this.locationDetails.site.siteName // setSiteName
                this.form.swappMethod = 'QRPHONE'
                this.form.swappedTime = this.$moment().format('X')
                // console.log(JSON.stringify(this.form, null, 2))
                //update the swapp status in the user document
                var updateDocumentResult2 = await this.MIX_updateDocument('users', this.form)
                if (updateDocumentResult2.code === 1) {
                    this.MIX_alert(1, 'Status Updated', updateDocumentResult2.data, null)
                    this.showSwappMessage = true // show success message
                    // Clear the selected site from localStorage after successful swap
                    localStorage.removeItem('selectedSiteId')
                } else {
                    this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult2.error)
                    this.showSwappMessage = false // show error message
                }
            } else {
                this.form.swappStatus = this.returnSwappValue // set Swapp status
                this.form.lastLocation.locationId = this.locationDetails.id // set locationId
                this.form.lastLocation.locationName = this.locationDetails.locationName // set locationName
                this.form.lastSite.siteId = this.locationDetails.site.id // set siteId
                this.form.lastSite.siteName = this.locationDetails.site.siteName // setSiteName
                this.form.swappMethod = 'QRPHONE'
                this.form.swappedTime = this.$moment().format('X')
                // console.log(JSON.stringify(this.form, null, 2))
                //update the swapp status in the user document
                var updateDocumentResult2 = await this.MIX_updateDocument('users', this.form)
                if (updateDocumentResult2.code === 1) {
                    this.MIX_alert(1, 'Status Updated', updateDocumentResult2.data, null)
                    this.showSwappMessage = true // show success message
                    // Clear the selected site from localStorage after successful swap
                    localStorage.removeItem('selectedSiteId')
                } else {
                    this.MIX_alert(-1, 'ERROR - Could not update Status', null, updateDocumentResult2.error)
                    this.showSwappMessage = false // show error message
                }
            }
        }
    },
    mounted() {
        this.getSites()
        this.getLocations()
        this.MIX_setQrCode('') // prevents cached values for qr codes
    }
}
</script>
